const host = "https://api.hotmic.io"; // [Prod]
// const host = "https://dev.api.hotmic.io"; // [Staging]
// const host = "https://portal-test.api.hotmic.io"; // [Cloud9] - TODO change this back to Prod before deploy
// This is pointed at cloud9 port 3001 (cause its the only DNS name we have for cloud9)
// TODO: create a DNS name for my cloud9 (platform-test.api.hotmic.io) and point it at port 3000

// const host = "http://35.91.92.145:3000";

export const fetchWrapperPlatform = async ({ ...args }) => {
  const fetchObj = {};
  fetchObj.headers = args.headers || {};
  fetchObj.method = args.method.toUpperCase();
  fetchObj.body = args.body ? args.body : null;
  fetchObj.headers["Content-Type"] = "application/json";
  fetchObj.headers["ApiKey"] = process.env.REACT_APP_APP_KEY;
  if (args.addBearer) {
    fetchObj.headers["Authorization"] = args.token ? args.token : `Bearer ${localStorage.getItem("access_token")}`;
  }
  try {
    const result = await fetch(`${host}/${args.url}`, fetchObj);
    return result && result.status === 204 ? result.status : await result.json();
  } catch (e) {
    console.log(`HTTP ERROR: ${e}`, args);
  }
};
